import React from 'react'
import { getEasiwareScriptInfo } from 'app/faq/utils'
import { EasiwareForm } from './EasiwareForm'
import { useAsyncScript } from 'hooks/useScript.hooks'

type Props = {
    theme?: string
}

const Easiware = (props: Props) => {
    const { theme = '' } = props
    const { formId, src, solutionId } = getEasiwareScriptInfo(theme)
    const divId = 'easiwebform-' + formId

    const { ready } = useAsyncScript({
        src,
        id: `easiwebform-${formId}`,
        charset: 'utf-8',
        type: 'text/javascript',
        appendToId: divId
    })

    return (
        <div id={divId}>
            {ready && (
                <EasiwareForm
                    formId={formId}
                    solutionId={solutionId}
                    divId={divId}
                    theme={theme}
                />
            )}
        </div>
    )
}

export { Easiware }
